<template>
  <div class="bg-book">
    <div class="button-area">
      <span class="switch-text" @click="myCourse=!myCourse">{{myCourse?'切换至全部课程':'切换至我的课程'}}</span>
    </div>
    <div class="book-area">
      <el-row>
        <el-col :span="4" v-for="book in books" :key="book.id" class="col">
          <div @click="showDialog(book)">
            <el-card class="book" :body-style="{ padding: '10px' }" shadow="hover">
              <div class="bookname" slot="header" style="height: 30px">
                {{book.name}}
              </div>
              <el-image class="bookimage" :src="`https://awesome-platform.oss-cn-shanghai.aliyuncs.com${book['cover_img_url']}`"></el-image>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-dialog
        :title="currentBook!=null?currentBook.name:''" style="text-align: left;line-height: 30px"
        :visible.sync="currentBookDialog"
        width="40%" center>
        <span style="font-size: 20px" v-html="currentBook!=null?currentBook.info:''"></span>
        <span v-if="currentBook!=null?isMyBook(currentBook.id):null" slot="footer" class="dialog-footer">
          <el-button @click="currentBookDialog = false">取 消</el-button>
          <el-button type="primary" @click="changeBook(currentBook)">进入课程</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapMutations } from 'vuex'

export default {
  data() {
    return {
      baseApi: '/book',
      books: [],
      myBooks: [],
      currentBook: null,
      currentBookDialog: false,
      myCourse: true,
    }
  },
  watch: {
    myCourse: function(n){
      if (n) {
        this.searchMyBook();
      } else {
        this.searchAllBook();
      }
    }
  },
  computed: {
    ...mapGetters({
      info: 'getInfo',
    })
  },
  created() {
    this.searchMyBook()
  },
  methods: {
    ...mapMutations([
      'setInfo'
    ]),
    searchMyBook() {
      this.$fly.post(`${this.baseApi}/unlocked/search-books`,{'studentAccountId.eLong': this.info.id}).then((res)=>{
        this.books = res
        this.myBooks = res
      })
    },
    searchAllBook() {
      this.$fly.post(`${this.baseApi}/unlocked/search-all-books`).then((res)=>{
        this.books = res
      })
    },
    showDialog(book) {
      this.currentBook = book;
      this.currentBookDialog = true;
    },
    changeBook(book) {
      // this.currentBookDialog = false
      let map = {
        'studentAccountId.eLong': this.info.id,
        'currentBookId': book.id
      }
      this.$fly.post(`${this.baseApi}/change-current-book`,map).then((res)=>{
        this.info['current_book_id'] = res
        this.setInfo(this.info);
        this.$emit('jump-study')
      })
    },
    isMyBook(id) {
      let ids = this.myBooks.map((e)=>e.id)
      return ids.indexOf(id)!=-1
    }
  }
}
</script>

<style scoped>
.bg-book{
  display: flex;
  flex-direction: column;
}
.book-area{
  padding: 20px 80px;
}
.book{
  border-radius: 10px
}
.bookimage{
  width: 90%;
  border-radius: 10px
}
.col{
  padding: 15px
}
@media screen and (max-width: 1400px) { 
  .bookname{
    font-size: 10px;
  }
  .book{
    border-radius: 5px
  }
  .bookimage{
    width: 90%;
    border-radius: 5px
  }
  .col{
    padding: 5px
  }
}
.button-area{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.switch-text{
  width: 130px;
  margin:  20px 90px 0 0;
  padding: 5px;
  border: 1px solid #000;
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
</style>
